import { IusefulDocServices } from './usefulDocsServices.types'
import { http } from '@/shared/https'

export class UsefulDocService implements IusefulDocServices {
    
   GetForPublic(){
    return http.get(`api/GmsUsefulDocument/GetUsefulDocuments`)
    .then((resp: any) => {
        return resp.data;
    });
   }
}